/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForOciSaasUserManagedOnboarded extends models.StorageConfigurationBaseForOciSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForOciSaasUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForOciSaasUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForOciSaasUserManagedOnboarded>): StorageConfigurationForOciSaasUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForOciSaasUserManagedOnboarded(), model);
        StorageConfigurationForOciSaasUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForOciSaasUserManagedOnboarded>): StorageConfigurationForOciSaasUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForOciSaasUserManagedOnboarded.newInstance(<StorageConfigurationForOciSaasUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForOciSaasUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForOciSaasUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForOciSaasUserManagedOnboarded): boolean {
        if (models.StorageConfigurationBaseForOciSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForOciSaasUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the Service Account under which the OCI bucket is present.
     */
    account_id: string;

}
